import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EQuestionnaireResponseHeaderColumnEnum {
  TITLE = 'title',
  ASSESSED_PARTNER = 'assessedPartner',
  DATE_COMPLETED = 'dateCompleted',
}

export type TQuestionnaireResponseHeaderColumn =
  keyof typeof EQuestionnaireResponseHeaderColumnEnum;

export const getQuestionnaireResponseHeaderColumns = (
  enabledColumns: EQuestionnaireResponseHeaderColumnEnum[]
) => {
  const columns: IHeaderColumn<EQuestionnaireResponseHeaderColumnEnum>[] = [];

  enabledColumns.forEach(column => {
    switch (column) {
      case EQuestionnaireResponseHeaderColumnEnum.TITLE:
        columns.push({
          id: EQuestionnaireResponseHeaderColumnEnum.TITLE,
          headerName: 'Title',
          sortable: false,
          align: 'left',
        });
        break;

      case EQuestionnaireResponseHeaderColumnEnum.ASSESSED_PARTNER:
        columns.push({
          id: EQuestionnaireResponseHeaderColumnEnum.ASSESSED_PARTNER,
          headerName: 'Assessed Partner',
          sortable: false,
          align: 'left',
        });
        break;

      case EQuestionnaireResponseHeaderColumnEnum.DATE_COMPLETED:
        columns.push({
          id: EQuestionnaireResponseHeaderColumnEnum.DATE_COMPLETED,
          headerName: 'Date completed',
          sortable: false,
          align: 'center',
        });
        break;
    }
  });

  return columns;
};
